import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import './notifications.css';
import './responsive.css';
import './security.css';
import './absence.css';
import './themes.css';
import './wide-layout.css';
import './chat.css';
import './generated/business-themes.css';
import './business.css';
import './generated/business-brand.css';
import './time-page.css';
import './companion-ui.css';
import './generated/selection.css';
import './responsive-layout.css';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(console.error));
}

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
